export default "__VITE_ASSET__Clb42jU4__"